import React, { useMemo } from "react";
import { Modal, Button } from "react-bootstrap";

/**
 * BasicModal
 * Props:
 * - show: boolean (required)
 * - onClose: function (required)
 * - title: string | ReactNode  // se stringa, può contenere HTML
 * - body: string | ReactNode  (opzionale; in alternativa usare children)
 * - onConfirm: function (opzionale)
 * - showConfirm: boolean (opzionale, default true) -> mostra/nasconde il bottone Conferma
 * - size: "xxl" | any (opzionale) -> se "xxl" applica layout full-width/height
 * - children: ReactNode (opzionale) -> contenuto del body, ha priorità su `body`
 * - isbodyhtml: boolean (opzionale, default false) -> se true e body è stringa, lo interpreta come HTML
 *
 * NOTE: se passi HTML in `title` o in `body` (con isbodyhtml),
 * assicurati che sia contenuto fidato (XSS).
 */
const BasicModal = ({
  show,
  onClose,
  title,
  body,
  onConfirm,
  showConfirm = true,
  textConfirm = "Conferma",
  size,
  children,
  isbodyhtml = false,
}) => {
  const isXXL = size === "xxl";

  const customStyles = useMemo(() => {
    if (!isXXL) return {};
    return {
      "--bs-modal-width": "90%",
      overflowY: "auto",
      "--bs-modal-padding": "1rem",
      "--bs-modal-margin": "0.5rem",
      "--bs-modal-zindex": "1055",
      minHeight: "40rem",
    };
  }, [isXXL]);

  const canShowConfirm = showConfirm && typeof onConfirm === "function";

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      centered
      dialogClassName={isXXL ? "custom-modal-dialog" : ""}
      contentClassName={isXXL ? "custom-modal-content" : ""}
      style={customStyles}
    >
      <div>
        <Modal.Header closeButton>
          <Modal.Title>
            {typeof title === "string" ? (
              <span dangerouslySetInnerHTML={{ __html: title }} />
            ) : (
              title
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{ height: isXXL ? "80vh" : undefined, overflowY: "auto" }}
        >
          {children
            ? children
            : typeof body === "string" && isbodyhtml
              ? <span dangerouslySetInnerHTML={{ __html: body }} />
              : body}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Chiudi
          </Button>
          {canShowConfirm && (
            <Button variant="primary" onClick={onConfirm}>
              {textConfirm}
            </Button>
          )}
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default BasicModal;
